// @flow

import React from 'react';
import { toString } from 'lodash';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';

import SubscriptionTooltip from '../../../components/ToolTip';
import Dropdown from '../../../components/Dropdown';

type Props = InjectIntlProvidedProps & {
  selected: string,
  subscriptionIsActive: boolean,
  onChange: (country: string) => any,
};

const messages = defineMessages({
  moldovaText: {
    id: 'filters.moldova',
    defaultMessage: 'Молдова',
  },
  allCountryText: {
    id: 'filters.allCountry',
    defaultMessage: 'Все страны',
  },
  othersText: {
    id: 'filters.others',
    defaultMessage: 'Другие',
  },
});

const Country = (props: Props) => {
  const disabled = !props.subscriptionIsActive;
  const { formatMessage } = props.intl;
  const countries = [
    { label: formatMessage(messages.moldovaText), value: 'MD' },
    { label: formatMessage(messages.allCountryText), value: 'ALL', disabled },
    { label: formatMessage(messages.othersText), value: 'NOT_MD', disabled },
  ];

  return (
    <FormattedMessage
      id="subscription.unavailableTooltip"
      defaultMessage="Полный отчет доступен с 999 Business."
    >
      {message => (
        <SubscriptionTooltip disabled={!disabled} title={toString(message)}>
          <Dropdown
            name="periodDays"
            selected={toString(props.selected)}
            options={countries}
            onChange={props.onChange}
            disabled={disabled}
          />
        </SubscriptionTooltip>
      )}
    </FormattedMessage>
  );
};

export default injectIntl(Country);
